import { AvailableAction } from 'src/models/orders/available.action.dto';
import { OrderAction } from 'src/models/orders/orderActions';


export class AvailableActionHandler {
	private availableActions: AvailableAction[];
	private readonly wantedAction: OrderAction;

	constructor(availableActions: AvailableAction[], wantedAction: OrderAction) {
		this.availableActions = availableActions;
		this.wantedAction = wantedAction;
	}

	private getAction(): AvailableAction | undefined {
		return this.availableActions.find((a: AvailableAction) => {
			return a.action === this.wantedAction;
		});
	}

	actionAllowed(): boolean {
		const action = this.getAction();
		return !!action && action.allowed;
	}

	actionAvailable(): boolean {
		const action = this.getAction();
		return !!action;
	}

}
